import React from 'react';
import { SETTINGS } from 'modules/emergencies/constants';
import { ReactComponent as OptionPremium1Icon } from 'assets/icons/optionPremium1.svg';
import { ReactComponent as OptionPremium2Icon } from 'assets/icons/optionPremium2.svg';
import BodyColumn from 'modules/emergencies/components/ui/columns/bodyColumn';
import IconsContainer from 'modules/emergencies/components/ui/icon/iconsContainer';
import IconWrapper from 'modules/emergencies/components/ui/icon/iconWrapper';
import { Tooltip } from '@ontruck/orc';
import { DeadlineTooltip, ServicesTooltip } from '../tooltips';

export const RequirementsColumn = ({ ticket }) => {
  return (
    <BodyColumn
      backgroundColor={'#FFFFFF'}
      width={SETTINGS.TICKETS_TABLE_COLUMN_SIZES_IN_PX.REQUIREMENTS}
    >
      <IconsContainer>
        <Tooltip component={<ServicesTooltip ticket={ticket} />} position="bottom" skin="dark">
          <IconWrapper
            active={
              !!ticket.order_data?.complementary_info?.additional_services &&
              ticket.order_data?.complementary_info?.additional_services.length !== 0
            }
          >
            <OptionPremium1Icon />
          </IconWrapper>
        </Tooltip>
        <Tooltip component={<DeadlineTooltip ticket={ticket} />} position="bottom" skin="dark">
          <IconWrapper
            active={!!ticket.order_data?.complementary_info?.customer_deadline}
            hasWarning={!!ticket.hasDeadlineWarning}
          >
            <OptionPremium2Icon />
          </IconWrapper>
        </Tooltip>
      </IconsContainer>
    </BodyColumn>
  );
};
